import React from 'react';
import { ScrollView } from 'react-native';
import BreadCrumbsContainer from 'src/components/10-atoms/BreadCrumbs/Container';
import Button from 'src/components/10-atoms/button/Button';
import { FileType } from 'src/components/10-atoms/file-picker/types';
import Field from 'src/components/10-atoms/form/Field';
import { getFieldError } from 'src/components/10-atoms/form/hooks/useFieldState/utils';
import FileInput from 'src/components/10-atoms/form/inputs/FileInput';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import Column from 'src/components/10-atoms/layout/Column';
import OverlayLayout from 'src/components/10-atoms/overlays/OverlayLayout';
import BottomDrawerLayout from 'src/components/20-helper-views/bottom-drawer/BottomDrawerLayout';
import { bottomDrawerHelperActions } from 'src/components/20-helper-views/bottom-drawer/useBottomDrawer';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import useEffectWithCtx from 'src/hooks/useEffectUtils/useEffectWithCtx';
import getBreadCrumbs from 'src/modules/exam-preparation/components/EPBreadCrumbs/getBreadCrumbs';
import ChangesSentForReviewDrawer from 'src/modules/exam-preparation/components/contributions/ChangesSentForReviewDrawer';
import EFImagesGuidelines from './EFImagesGuidelines';
import useData from './useData';
const EFFormOverlay = ({ qpID, onClose, onComplete, }) => {
    const [{ theme }] = useTheme(stylesGenerator);
    const [state, actions] = useData(qpID);
    useEffectWithCtx(ctx => {
        if (ctx.state.uploadMutation.data) {
            ctx.actions.contributionResponseHandler.handle(ctx.state.uploadMutation.data.ep_uploadEF).then(ctx.onComplete).catch((error) => {
                console.log('Failed to upload QP:', error);
            });
        }
    }, { onComplete, actions, state }, [state.uploadMutation.data]);
    return (React.createElement(Column, { flex: true },
        React.createElement(OverlayLayout.FormHeader, { title: "Upload Examiners Feedback", onClose: onClose }),
        React.createElement(Column, { flex: true },
            React.createElement(ScrollView, null,
                React.createElement(Column, { spacing: theme.spacing.standard.md, ph: theme.spacing.page, pv: theme.spacing.standard.sm },
                    React.createElement(Field, { label: "Question Paper" },
                        React.createElement(BreadCrumbsContainer, { loading: state.qpDetailsQuery.loading, crumbs: getBreadCrumbs({}, {
                                ...state.qpDetailsQuery.data?.ep_qp
                                    .ancestorsDetails,
                                qp: state.qpDetailsQuery.data?.ep_qp,
                            }), visibleCount: 10 })),
                    React.createElement(Field, { label: "Examiners Feedback Image(s)", error: getFieldError(state.form.fields.efImages.errors) },
                        React.createElement(FileInput, { allowedTypes: [FileType.IMAGES, FileType.PDF], value: state.form.fields.efImages.value, onChange: actions.form.fields.efImages.setValue, maxCount: 20 }),
                        React.createElement(EFImagesGuidelines, null))),
                React.createElement(Column, { style: { height: 400 } }))),
        React.createElement(BottomDrawerLayout.Actions, { btw: 1, spacing: theme.spacing.standard.md, pv: theme.spacing.standard.sm },
            React.createElement(Button, { disabled: state.uploadMutation.loading, flex: true, variant: "outline", onPress: () => {
                    bottomDrawerHelperActions.show({
                        component: (React.createElement(ChangesSentForReviewDrawer, { title: "Examiners Feedback sent for review \uD83C\uDF89", onConfirm: bottomDrawerHelperActions.hide })),
                    });
                } }, "Cancel"),
            React.createElement(Button, { loading: state.uploadMutation.loading, flex: true, LeftIcon: props => React.createElement(FeatherIcon, { name: "save", ...props }), onPress: actions.handleSubmit }, "Submit"))));
};
const stylesGenerator = createThemedStyle(({}) => ({}));
export default EFFormOverlay;
